import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate,DownloadFile } from './Function';
import { usePage } from '../PageContext';
import { Card,Table,Placeholder } from 'react-bootstrap';
const NoticesDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Notices,setNotices]=useState([]);
    useEffect(()=>
    {
        const NoticesDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"notices/details/"+htaccess);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sn_id + "/snFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sn_id + "/snFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].snFile = el.upp;
                            result[i].snFileHi = el.upb;
                        });
                        setNotices(result[0]);
                        currentPage(result[0]);
                        setLoading(false);
                    }).catch(error => {
                        console.error('NoticesDetails File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setNotices([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === true ) { console.info('NoticesDetails : Result',result); }
            } catch (error)
            {
                console.error('NoticesDetails : Error', error.message);
                setLoading(false);
            }
        };
        
        NoticesDetails();
        // eslint-disable-next-line
    },[htaccess])
    return (
        <Card>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {t('NoticeDetails')}
            </Card.Header>
            <Card.Body>                    
                {isLoading ? (
                <Table responsive bordered className='mb-0'>
                <tbody>
                    {[...Array(5)].map((_,index)=>(
                    <tr key={index}>
                        <th className="table-success w-25 text-end"><Placeholder xs={10} /></th>
                        <td className="text-center"><Placeholder xs={10} /></td>
                    </tr>
                    ))}
                </tbody>
                </Table>
                ) : (
                <React.Fragment>
                {Notices.sn_id > 0 ? (
                <Table responsive bordered className='mb-0'>
                <tbody>                                    
                    <tr>
                        <th className="table-success w-25 text-end">{t('Title')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Notices.sn_display_en === "1" ? Notices.sn_name_hi || '' : Notices.sn_name_hi || Notices.sn_name) : Notices.sn_name }}></th>
                    </tr>                                    
                    <tr>
                        <th className="table-success w-25 text-end">{t('Content')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Notices.sn_display_en === "1" ? Notices.sn_description_hi || '' : Notices.sn_description_hi || Notices.sn_description) : Notices.sn_description }}></th>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Type')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? ( Notices.noticeType.nt_name_hi ? Notices.noticeType.nt_name_hi : Notices.noticeType.nt_name ) : Notices.noticeType.nt_name }}></th>
                    </tr>                                   
                    <tr>
                        <th className="table-success w-25 text-end">{t('Download')}:</th>
                        <td dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,Notices.snFile,Notices.snFileHi)}} />
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('UploadDate')}:</th>
                        <td>{formatDate(Notices.sn_date)}</td>
                    </tr>
                </tbody>
                </Table>
                ) : (
                <div className='text-center lead fw-bold'>
                    {appLanguage === 'hi' ? 'हमें वह नोटिस नहीं मिल रहा है जिसका विवरण हम आपको दिखाना चाहते थे।' : "We can't find the notice whose details we wanted to show you."}
                </div>
                )}
                </React.Fragment>                    
                )}                    
            </Card.Body>
        </Card>
    );
}
export default NoticesDetails;